import {
  Action,
  ActionType,
  IDepartmentList4DashboardResponse,
} from "models/dashboard/departmentList";
import createReducer from "../../createReducer";

export interface DepartmentList4DashboardReducerType {
  loading: boolean;
  error?: string;
  departmentList4DashboardResponse?: IDepartmentList4DashboardResponse;
}

const defaultState: DepartmentList4DashboardReducerType = {
  loading: false,
  error: undefined,
  departmentList4DashboardResponse: undefined,
};

export const getDepartmentList4DashboardReducer =
  createReducer<DepartmentList4DashboardReducerType>(defaultState, {
    [ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD](
      state: DepartmentList4DashboardReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD_ERROR](
      state: DepartmentList4DashboardReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD_SUCCESS](
      state: DepartmentList4DashboardReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        departmentList4DashboardResponse: action.payload,
      };
    },
  });
